import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Card, Button, Form, Spinner } from 'react-bootstrap';
import { usePurchase } from '../../../context/PurchaseContext';
import { apiCreatePayment } from '../../../api/api';
import { useUser } from '../../../context/UserContext';
import { useToast } from '../../../context/ToastContext';

const Payment = () => {
  const { purchase, clearPurchase } = usePurchase();
  const { user, updateUser } = useUser();
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { addToast } = useToast();
  const [selectedMonth, setSelectedMonth] = useState('');
  const [selectedYear, setSelectedYear] = useState('');
  const [formData, setFormData] = useState({
    cep: '',
    state: '',
    city: '',
    card: '',
    name: '',
    email: '',
    document: '',
    cvv: '',
    card_number: '',
    card_holder_name: '',
    card_exp_month: '',
    card_exp_year: '',
    card_cvv: '',
    billing_line_1: '',
    billing_zip_code: '',
    billing_city: '',
    billing_state: ''
  })


  const planName = (planId) => {
    if (parseInt(planId) === 1) {
      return 'MENSAL';
    } else if (parseInt(planId) === 2) {
      return 'ANUAL (Á Vista)';
    } else {
      return 'ANUAL (Parcelado)';
    }
  }

  const planPrice = (planId) => {
    if (parseInt(planId) === 1) {
      return <div><i className="bi bi-award"></i> R$ 190,00</div>;
    } else if (parseInt(planId) === 2) {
      return <div><i className="bi bi-award-fill"></i> R$ 1.080,00</div>;
    } else {
      return <div><i className="bi bi-trophy-fill"></i> 4 x R$ 310,00</div>;
    }
  }

  const formatDate = (date) => {
    if (!date) {
        return '';
    }
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Mês começa do zero
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
};

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const data = {
      card: formData.get('card'),
      name: formData.get('name'),
      month: formData.get('month'),
      year: formData.get('year'),
      cvv: formData.get('cvv'),
    };

    try {
      purchase.userId = user.id;
      purchase.card = data.card;
      purchase.name = data.name;
      purchase.month = data.month;
      purchase.year = data.year;
      purchase.cvv = data.cvv;

      const response = await apiCreatePayment(purchase);
      const responseData = await response.json();
      if (response && response.ok) {
        addToast('Pagamento efetuado com sucesso.');
        console.log(user);
        const updatedUser = { ...user, subscription: parseInt(purchase.planId), releasedDeadline: formatDate(new Date(new Date().setFullYear(new Date().getFullYear() + 1))) };  
        updateUser(updatedUser);
        console.log(updatedUser);
        clearPurchase();
        navigate('/main');
      } else {
        if (responseData.error) {
          addToast(responseData.error);
        } else {
          addToast('Erro ao processar pagamento.');
        }
      }
    } catch (error) {
      addToast('Erro ao processar pagamento.');
    } finally {
      setLoading(false);
    }
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleBack = () => {
    navigate(`/main/purchase/${purchase.planId}`);
  }

  return (
    <>
      {purchase && (
        <Container className="">
          <Row>
            <Col md={4}>
              <Card>
                <Card.Header className="bg-secondary text-white">{planName(purchase.planId)}</Card.Header>
                <Card.Body>
                  <Card.Text as="div">
                    <h2> {planPrice(purchase.planId)}</h2>
                    <hr />
                    <div>Acesso às bases de dados de insumos e serviços da construção civil de forma organizada, completa, íntegra e com consistência técnica por <b>30 dias</b>.</div>
                  </Card.Text>
                </Card.Body>
                <Card.Footer>
                  <Button size="sm" variant="outline-secondary" onClick={handleBack}>VOLTAR</Button>
                </Card.Footer>
              </Card>
            </Col>

            <Col md={8}>
              <Form onSubmit={handleSubmit}>
                <Card>
                  <Card.Header className="bg-secondary text-white">DADOS DE PAGAMENTO. ETAPA 1 / 2</Card.Header>
                  <Card.Body>
                    <Card.Text as="div">

                      <Form.Group className="mb-1">
                        <Form.Label>Número do cartão:</Form.Label>
                        <Form.Control
                          size='sm'
                          type="text"
                          name='card'
                          required
                          autoComplete='false'
                          maxLength={16}
                          onChange={handleInputChange}
                          value={formData.card}
                        />
                      </Form.Group>

                      <Form.Group className="mb-1">
                        <Form.Label>Nome no cartão:</Form.Label>
                        <Form.Control
                          size='sm'
                          type="text"
                          name='name'
                          required
                          autoComplete='false'
                          onChange={handleInputChange}
                          value={formData.name}
                        />
                      </Form.Group>

                      <Form.Group className="mb-1">
                        <Form.Label>Mês do vencimento:</Form.Label>
                        <Form.Select
                          size='sm'
                          name='month'
                          required
                          autoComplete='false'
                          value={formData.month}
                          onChange={(e) => setSelectedMonth(e.target.value)}
                        >
                          {Array.from({ length: 12 }, (_, index) => {
                            const month = (index + 1).toString().padStart(2, '0');
                            return (
                              <option key={index + 1} value={month}>{month}</option>
                            );
                          })}
                        </Form.Select>
                      </Form.Group>

                      <Form.Group className="mb-1">
                        <Form.Label>Ano do vencimento:</Form.Label>
                        <Form.Select
                          size='sm'
                          name='year'
                          required
                          autoComplete='false'
                          value={formData.year}
                          onChange={(e) => setSelectedYear(e.target.value)}
                        >
                          {Array.from({ length: 10 }, (_, index) => {
                            const year = currentYear + index;
                            return (
                              <option key={index + 1} value={year}>{year}</option>
                            );
                          })}
                        </Form.Select>
                      </Form.Group>

                      <Form.Group className="mb-1">
                        <Form.Label>Código CVV:</Form.Label>
                        <Form.Control
                          size='sm'
                          type="text"
                          name='cvv'
                          required
                          autoComplete='false'
                          maxLength={3}
                          onChange={handleInputChange}
                          value={formData.cvv}
                        />
                      </Form.Group>
                    </Card.Text>
                  </Card.Body>
                  <Card.Footer>
                    <Button variant="primary" type="submit" disabled={loading}>
                      {loading ?
                        <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                        :
                        'CONTRATAR'
                      }
                    </Button>
                  </Card.Footer>
                </Card>
              </Form>
            </Col>

          </Row>
        </Container>
      )}
    </>
  );
};

export default Payment